/**
 * Ambient dimensions merged into every telemetry item.
 *
 * Names are PascalCase and deliberately match the backend's Serilog properties so a single
 * KQL `project` works across client and server items:
 *   ApplicationName  -- mirrors Enrich.WithProperty("ApplicationName", ...)
 *   EnvironmentName  -- mirrors Enrich.WithEnvironmentName()
 * Note this is the ASP.NET environment name ("Test"), not SiteSettings.Environment, which is
 * a UI banner label ("Unity TEST") and would never join with the server.
 */
export const BROWSER_ROLE_NAME = 'Unity Web Browser';

let globalContext = { ApplicationName: BROWSER_ROLE_NAME };

export function setGlobalContext(properties) {
  globalContext = { ...globalContext, ...properties };
}

export function clearGlobalContext(keys) {
  const next = { ...globalContext };
  keys.forEach((key) => delete next[key]);
  globalContext = next;
}

export function getGlobalContext() {
  return globalContext;
}

/** Test hook: restore the module to its initial state. */
export function resetGlobalContext() {
  globalContext = { ApplicationName: BROWSER_ROLE_NAME };
}
